//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/lib/util';
import {ImagePreview} from 'vant';

export default {
    components: {
        [ImagePreview.Component.name]: ImagePreview.Component,
    },
    data() {
        return {
            typeList: [ //分类列表 
                {name: '全部'}, {name: '亲子'}, {name: '旅游'}, {name: '家园'},
                {name: ' 物业 '}, {name: '运动'}, {name: '美景'}
            ],
            typeIndex: 0, //分类索引  

            dataList: [], //列表数据 
            haveData: 0, //是否有数据，1=无，2=有，0=页面还未初始化 
            pageIndex: 1, //页码 
            pageSize: 8, //每页加载数据数量 
            isLoading: false,  //下拉刷新进行中，请求开始true, 请求完成false，用于下拉刷新组件van-pull-refresh 
            loading: false,  //上拉加载更多中，上拉触底时自动变成true, 请求完成设置为false, 用于列表组件van-list 
            finished: true, //上拉加载是否加载完最后一页数，用于组件van-list  
            timer: null,
            itemCount: 0, //上一次加载完成后的瀑布流item个数
            lastRowHeights: [0, 0], //最后一行标签的顶部间距+高度，2列 

            boxMargin: 15, //每个item之间的边距
            boxWidth: 165, //每个item宽度 
            tag: '',
            downloadUrl: util.ApiUrl + '/file/download/',
            id: '',
            album: {},
            images: [],
            showPreview: false
        }
    },
    methods: {
        /*changeType(index, tag) { //切换类型
            if (this.typeIndex == index) return;

            this.$toast.loading({
                message: '加载中...',
                duration: 0
            });
            if (tag == '全部') {
                this.tag = '';
            } else {
                this.tag = tag;
            }

            this.dataList = [];
            this.typeIndex = index;
            this.onRefresh();
        },*/
        onRefresh() { //下拉刷新
            if (!this.timer) {
                this.timer = setTimeout(() => {
                    this.pageIndex = 1; //重置第一页
                    this.isLoading = true; //开始加载
                    this.finished = false; //上拉加载"所有数据已经完成"标识 重置为false

                    //接口请求
                    this.getDataList();
                    this.timer = null;
                }, 1000)
            }

            // if (this.isLoading) return; //还在请求中，返回


        },
        onBottomLoad() { //上拉加载更多
            if (this.finished) return; //说明所有数据已经加载完毕，返回

            this.getDataList(); //下一页数据请求中
        },
        //数据请求
        getDataList() {

            var p = {
                tag: this.tag,
                maxResultCount: this.pageSize,
                skipCount: (this.pageIndex - 1) * this.pageSize
            };

            abp.ajax.get('/api/services/app/Album/GetAlbumById?id=' + this.id).then((resp) => {
                this.album = resp.data.result;

                let list = this.album.images ? this.album.images : [];
                if (list.length > 0) {
                    //从list中取pageSize条数据出来
                    var tempList = [];
                    for (let i = 0; i < this.pageSize; i++) {
                        if (list.length > 0) {
                            let tempIndex = parseInt(Math.random() * 1000) % list.length;
                            tempList.push(list[tempIndex]);
                            list.splice(tempIndex, 1);
                        }
                    }
                    this.loadImagesHeight(tempList); //模拟预加载图片，获取图片高度
                } else {
                    // this.loadImagesHeight(list); //处理数据
                    this.$toast.clear();
                    this.finished = true;
                }

            }).finally(() => {
                this.loading = true;
            });

            // abp.ajax.post('/api/services/app/Photo/SearchPhotos?id=' + this.id, p).then(res => {
            //     console.log(this.albumId)
            //
            //     // this.$axios.get("/json/dataList.json").then((res)=>{
            //
            //     let list = res.data.result.items ? res.data.result.items : [];
            //     if (list.length > 0) {
            //         //从list中取pageSize条数据出来
            //         var tempList = [];
            //         for (let i = 0; i < this.pageSize; i++) {
            //             if (list.length > 0) {
            //                 let tempIndex = parseInt(Math.random() * 1000) % list.length;
            //                 tempList.push(list[tempIndex]);
            //                 list.splice(tempIndex, 1);
            //             }
            //         }
            //         this.loadImagesHeight(tempList); //模拟预加载图片，获取图片高度
            //     } else {
            //         // this.loadImagesHeight(list); //处理数据
            //         this.$toast.clear();
            //         this.finished = true;
            //     }
            // }).catch((res) => {
            //     console.log("..fail: ", res);
            //     this.$toast.clear();
            //     this.isLoading = false; //下拉刷新请求完成
            //     this.loading = false; //上拉加载更多请求完成
            // })
        },
        loadImagesHeight(list) {
            var count = 0; //用来计数，表示是否所有图片高度已经获取
            // console.log('------------');
            // console.log(list);
            list.forEach((item, index) => {
                //创建图片对象，加载图片，计算图片高度
                var img = new Image();
                // img.src = item.cover;
                // if (item.files.length > 0) {
                img.src = this.downloadUrl + item.fileId;
                // }

                img.onload = img.onerror = (e) => {
                    count++;
                    if (e.type == 'load') { //图片加载成功
                        //计算图片缩放后的高度：图片原高度/原宽度 = 缩放后高度/缩放后宽度
                        list[index].imgHeight = Math.round(img.height * this.boxWidth / img.width);
                        // console.log('index: ', index, ', load suc, imgHeiht: ', list[index].imgHeight);
                    } else { //图片加载失败，给一个默认高度50
                        list[index].imgHeight = 50;
                        // console.log("index： ", index, "， 加载报错：", e);
                    }

                    //加载完成最后一个图片高度，开始下一步数据处理
                    if (count == list.length) {
                        this.resolveDataList(list);
                    }
                }
            })
        },
        resolveDataList(list) { //处理数据
            //下拉刷新，清空原数据
            if (this.pageIndex <= 1) {
                this.itemCount = 0;
                this.dataList = [];
                this.lastRowHeights = [0, 0]; //存储每列的最后一行高度清0
            }

            if (list.length >= this.pageSize) {
                this.pageIndex++;  //还有下一页
            } else {
                this.finished = true; //当前tab类型下所有数据已经加载完成
            }

            //合并新老两个数组数据
            this.dataList = [...this.dataList, ...list];
            //判断页面是否有数据
            this.haveData = this.dataList.length > 0 ? 2 : 1;
            this.isLoading = false; //下拉刷新请求完成
            this.loading = false; //上拉加载更多请求完成

            // console.log("...datalist: ", this.dataList);
            // console.log("...this.isLoading: ", this.isLoading)

            this.$nextTick(() => {
                setTimeout(() => {
                    //渲染完成，计算每个item宽高，设置标签坐标定位
                    this.setItemElementPosition();
                    this.isLoading = false; //下拉刷新请求完成
                    this.loading = false; //上拉加载更多请求完成
                }, 1000)
            });
        },
        //获取每个item标签高度，设置item的定位
        setItemElementPosition() {
            let parentEle = document.getElementById('data-list-box');
            let boxEles = parentEle.getElementsByClassName("data-item");

            for (let i = this.itemCount; i < boxEles.length; i++) {
                let tempEle = boxEles[i];
                //上一个标签最小高度的列索引
                let curColIndex = this.getMinHeightIndex(this.lastRowHeights);
                let boxTop = this.lastRowHeights[curColIndex] + this.boxMargin;
                let boxLeft = curColIndex * (this.boxWidth + this.boxMargin) + this.boxMargin;
                tempEle.style.left = boxLeft + 'px';
                tempEle.style.top = boxTop + 'px';
                this.lastRowHeights[curColIndex] = boxTop + tempEle.offsetHeight;

                // console.log('i = ', i, ', boxTop: ', boxTop, ', eleHeight: ', tempEle.offsetHeight);
            }

            this.itemCount = boxEles.length;

            //修改父级标签的高度
            let maxHeight = Math.max.apply(null, this.lastRowHeights);
            parentEle.style.height = maxHeight + 'px';

            this.$toast.clear();
            // console.log("...boxEles: ", boxEles.length, ", maxH: ", maxHeight);
        },
        //获取数组中最小值的索引
        getMinHeightIndex(arr) {
            var minHeight = Math.min.apply(null, arr);
            for (let i = 0; i < arr.length; i++) {
                if (arr[i] == minHeight) {
                    return i;
                }
            }
        },
        getAlbum() {
            this.loading = true;
            abp.ajax.get('/api/services/app/Album/GetAlbumById?id=' + this.id).then((resp) => {
                this.album = resp.data.result;
            }).finally(() => {
                this.loading = false;
            });
        },
        showImagePreview(url) {
            // console.log(url)
            this.images = [];
            this.images.push(url);
            this.showPreview = true;
        }
    },
    created() {
        this.$toast.loading({
            //message: '加载中...',
            duration: 0
        });
        //当前瀑布流设置为两列，计算瀑布流每个item和图片的宽度
        let screenWidth = document.body.offsetWidth; //屏幕宽度
        this.boxWidth = (screenWidth - this.boxMargin * 3) / 2; //每个item的宽度
        this.onRefresh(); //刷新数据

        this.id = this.$route.params.id;
        // this.getAlbum();
    },


}
